/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { runWithRetry } from "@fluidframework/driver-utils/internal";
export class RetriableGitManager {
    constructor(internalGitManager, logger) {
        this.internalGitManager = internalGitManager;
        this.logger = logger;
    }
    async getCommits(sha, count) {
        return this.runWithRetry(async () => this.internalGitManager.getCommits(sha, count), "gitManager_getCommits");
    }
    async getTree(root, recursive) {
        return this.runWithRetry(async () => this.internalGitManager.getTree(root, recursive), "gitManager_getTree");
    }
    async getBlob(sha) {
        return this.runWithRetry(async () => this.internalGitManager.getBlob(sha), "gitManager_getBlob");
    }
    async createBlob(content, encoding) {
        return this.runWithRetry(async () => this.internalGitManager.createBlob(content, encoding), "gitManager_createBlob");
    }
    async createGitTree(params) {
        return this.runWithRetry(async () => this.internalGitManager.createGitTree(params), "gitManager_createGitTree");
    }
    async createSummary(summary) {
        return this.runWithRetry(async () => this.internalGitManager.createSummary(summary), "gitManager_createSummary");
    }
    async getSnapshot(sha) {
        return this.runWithRetry(async () => this.internalGitManager.getSnapshot(sha), "gitManager_getSummary");
    }
    async runWithRetry(api, callName) {
        return runWithRetry(api, callName, this.logger, {});
    }
}
//# sourceMappingURL=retriableGitManager.js.map